import {AppState} from '@app/context/context';

const SEARCH_COLUMNS_KEY = 'searchColumns';

class SearchColumnsStorage {
    set = (config: AppState['search']['config']) =>
        localStorage.setItem(SEARCH_COLUMNS_KEY, JSON.stringify(config));

    get = (): AppState['search']['config'] | null => {
        const storedConfig = localStorage.getItem(SEARCH_COLUMNS_KEY);
        return storedConfig ? JSON.parse(storedConfig) : null;
    };

    clear = () => localStorage.removeItem(SEARCH_COLUMNS_KEY);
}

export const searchColumnsStorage = new SearchColumnsStorage();